// POS comments item 5: on a product with variants the Selling Price and Cost
// (WAC) cards read the parent's own price and cost — 0 when only the variants
// carry them. The cards show the active variants' range instead.

export interface VariantPricing {
  is_active?: boolean;
  price?: number | null;
  cost?: number | null;
}

/** min/max of one field over the active variants, or null when there are none. */
export function activeVariantRange(
  variants: VariantPricing[],
  field: 'price' | 'cost',
): { min: number; max: number; count: number } | null {
  const values = variants
    .filter((v) => v.is_active !== false)
    .map((v) => Number(v[field] ?? 0));
  if (values.length === 0) return null;
  return { min: Math.min(...values), max: Math.max(...values), count: values.length };
}

/** "OMR0.200" when every variant agrees, else "OMR0.200 – OMR0.600". */
export function formatRange(range: { min: number; max: number }, format: (minor: number) => string): string {
  return range.min === range.max ? format(range.min) : `${format(range.min)} – ${format(range.max)}`;
}
